import store from '../store';
import growthBook from '../services/growthBook';

/**
 * GrowthBook feature base passed to getGrowthBookFeature (resolved key `{name}_{brand}`).
 */
export const welcomeDigitalDiscountGrowthBookFeatureBase = 'show_discount_banner';

/**
 * Whether the Welcome Digital Discount experiment is on (GrowthBook vs whitelabel SHOW_WELCOME_DIGITAL_DISCOUNT_BANNER).
 * This gates the modal / message from {@link shouldShowWelcomeDigitalDiscount}, not the trip-list
 * {@link DiscountBanner} atom (that strip uses SHOW_DIGITAL_DISCOUNT_BANNER and its own layout rules).
 *
 * @returns {boolean} Whether the rollout flag allows welcome digital discount UX.
 */
export const welcomeDigitalDiscountIsExperimentEnabled = () => {
  const featureName = 'SHOW_WELCOME_DIGITAL_DISCOUNT_BANNER';
  const { features } = store.getState().whitelabelConfig;
  const featureValue = growthBook.getGrowthBookFeature(featureName.toLowerCase());
  return featureValue ?? features[featureName];
};
